import HttpResponse from "../../../../../utils/http/http.response";

export enum OrderCancelRevertRequestNotAcceptableResponseErrorType {
  ORDER_CANCELLED = "ORDER_CANCELLED",
  ORDER_CANCEL_NOT_REQUESTED = "ORDER_CANCEL_NOT_REQUESTED",
  ORDER_FINISHED = "ORDER_FINISHED",
}

export type OrderCancelRevertRequestNotAcceptableResponseOrderCancelledError = {
  errorType: OrderCancelRevertRequestNotAcceptableResponseErrorType.ORDER_CANCELLED;
};

export type OrderCancelRevertRequestNotAcceptableResponseOrderCancelNotRequestedError =
  {
    errorType: OrderCancelRevertRequestNotAcceptableResponseErrorType.ORDER_CANCEL_NOT_REQUESTED;
  };

export type OrderCancelRevertRequestNotAcceptableResponseOrderFinishedError = {
  errorType: OrderCancelRevertRequestNotAcceptableResponseErrorType.ORDER_FINISHED;
};

export type OrderCancelRevertRequestNotAcceptableResponseError =
  | OrderCancelRevertRequestNotAcceptableResponseOrderCancelledError
  | OrderCancelRevertRequestNotAcceptableResponseOrderCancelNotRequestedError
  | OrderCancelRevertRequestNotAcceptableResponseOrderFinishedError;

type OrderCancelRevertRequestSuccessResponse = HttpResponse<null>;

export type OrderCancelRevertRequestNotAcceptableResponse =
  HttpResponse<OrderCancelRevertRequestNotAcceptableResponseError>;

type OrderCancelRevertRequestResponse =
  | OrderCancelRevertRequestSuccessResponse
  | OrderCancelRevertRequestNotAcceptableResponse;

export default OrderCancelRevertRequestResponse;
